import React, {FC, useEffect, useState} from "react";
import SGBManager from "../service/TickManager";
import GatewayService, {Client} from "../service/GatewayService";
import AppUtil from "../util/AppUtil";

interface IProps {
    focus:boolean,
    stepBack:boolean,
    isLoggedIn:boolean,
    brs:boolean,
}

const ConfigComponent: FC<IProps> = (props) => {
    const[stepBack, setStepBack] = useState(props.stepBack);
    const[goldPrice, setGoldPrice] = useState(-100);
    const[avgGoldPrice, setAvgGoldPrice] = useState(goldPrice+"");
    const[volume, setVolume] = useState(0);
    const[brs, setBRS] = useState(props.brs);
    const[_,refresh] = useState(0)

    useEffect(() => {
        refresh(AppUtil.currentTime)
    }, [props]);
    useEffect(()=>{
        GatewayService.goldPrice().then(resp => setGoldPrice(resp.second))
    }, [])
    setInterval(()=>{
        const [avg,volume] = SGBManager.getAvgTradedPrice()
        setAvgGoldPrice(avg.toFixed(1))
        setVolume(volume)
    }, 1000)

    async function _setStepBack(stepBack: boolean) {
        let status = await GatewayService.setStepBack(stepBack);
    }

    async function _setBRS(val:boolean) {
        let brs = await GatewayService.setBrs(val)
        setBRS(brs.brs)
    }

    function toggleFullScreen(){
        AppUtil.toggleFullScreen()
    }

    function analyse() {
        GatewayService.analyseMarket().catch(console.error)
    }

    return <div>
        <table className={"small"}>
            <tbody>
                <tr>
                    <td><button onClick={toggleFullScreen}>full screen</button></td>
                    <td><a href={"https://www.ibjarates.com/"} target="_blank">{goldPrice}/{avgGoldPrice}-{volume}</a></td>
                    <td><button onClick={()=> _setBRS(!brs)}>BRS is {brs ? "ON" : "OFF"}</button></td>
                    <td><button onClick={()=> _setStepBack(!stepBack)}>StepBack - {!stepBack + ""}</button></td>
                    <td>
                    </td>
                    <td><button onClick={()=> analyse()}>Analyse market</button></td>
                </tr>
            </tbody>
        </table>
    </div>
}

export default ConfigComponent;